export default __webpack_public_path__ + "static/Quickinstallation_Lense-Adjust_5907_04-c3cd9c8e842c4ce501f2d1f51495f01e.webp";